module.exports = __webpack_public_path__ + "img/img_1@2x.f9b29b2f.png";